var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"outlined":"","rounded":"","color":"#000","small":""},on:{"click":_vm.onBackBtnClick}},[_c('v-icon',{attrs:{"size":"16"}},[_vm._v("mdi-chevron-left")]),_vm._v(" "+_vm._s(_vm.$t("common.back"))+" ")],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }